import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cert-manager-solvers"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import CertManagerResourceTabs from './CertManagerResourceTabs.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import { CERTIFICATE_HEADERS } from '../table-headers';
import { useRelatedTypes } from '../composables/useRelatedTypes';
import { CERT_MANAGER } from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'IssuerDetail',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

// Related resources are read from the store; a directly loaded detail page has none yet. Gate the
// related-data parts of the template on `loaded` so they render against the populated store.
const { loaded } = useRelatedTypes([CERT_MANAGER.CERTIFICATE]);

const { t } = useI18n(useStore());

const isAcme = computed(() => props.value.configType === 'acme');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CertManagerResourceTabs, { value: __props.value }, {
      default: _withCtx(() => [
        (isAcme.value)
          ? (_openBlock(), _createBlock(Tab, {
              key: 0,
              name: "solvers",
              label: _unref(t)('certManager.issuer.tab.solvers'),
              weight: 30
            }, {
              default: _withCtx(() => [
                (__props.value.solverSummaries.length)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_unref(t)('certManager.issuer.solver.challengeType')), 1),
                          _cache[0] || (_cache[0] = _createTextVNode()),
                          _createElementVNode("th", null, _toDisplayString(_unref(t)('certManager.issuer.solver.provider')), 1),
                          _cache[1] || (_cache[1] = _createTextVNode()),
                          _createElementVNode("th", null, _toDisplayString(_unref(t)('certManager.issuer.solver.selector')), 1)
                        ])
                      ]),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value.solverSummaries, (solver, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("td", null, _toDisplayString(solver.type), 1),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createElementVNode("td", null, _toDisplayString(solver.provider || '—'), 1),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createElementVNode("td", null, [
                              (solver.selector.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(solver.selector.join(', ')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('certManager.issuer.solver.catchAll')), 1))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('certManager.issuer.solver.none')), 1))
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createTextVNode()),
        _createVNode(Tab, {
          name: "certificates",
          label: _unref(t)('certManager.issuer.tab.certificates'),
          weight: 20
        }, {
          default: _withCtx(() => [
            _createVNode(ResourceTable, {
              rows: _unref(loaded) ? __props.value.certificates : [],
              headers: _unref(CERTIFICATE_HEADERS),
              "table-actions": false,
              groupable: false
            }, null, 8, ["rows", "headers"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})